import React from 'react';
import { useTranslation } from 'react-i18next';

import './PSample.scss';

const PBook = ({ item, withBorderBottom, RemoveCart, books = [] }) => {
  const { i18n } = useTranslation();
  const sample = JSON.parse(item.is_available_json)?.sample;
  
  // Trova il book corrispondente usando codice_sample (che è item_id)
  const book = books.find(b => b.item_id === sample?.codice_sample);
  
  const handleOnError = ({ currentTarget }) => {
    currentTarget.onerror = null;
    currentTarget.src = '/images/artic_06.jpg';
  };

  return (
    <div className={`p-sample ${withBorderBottom ? 'with-border-bottom' : ''}`}>
      {book?.image_path && (
        <img 
          src={book.image_path} 
          onError={handleOnError} 
          alt={sample?.name || item.product_name}
          className="book-image"
        />
      )}
      <div className="details">
        <div className="title">{sample?.name || item.product_name}</div>
        {RemoveCart ? (
          <div className="actions">
            <div className="delete_order">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  RemoveCart(item?.id);
                }}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PBook;
